import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';

/**
 * Represents a Floating FloatingCard
 *
 * @class FloatingCard
 * @extends React.Component
 */
class FloatingCard extends React.Component {
  /**
   * Constructs a Floating FloatingCard
   *
   * @method constructor
   * @constructor
   * @param {Object} props - Properties passed by parent
   */
  constructor(props) {
    super(props);
    this.state = {
      elevation: 2,
    };
  }

  /**
   * Handles event where mouse is over Floatng FloatingCard.
   *
   * @method onMouseOver
   */
  onMouseOver = () => this.setState({ elevation: 24 });

  /**
   * Handles event where mouse moves out of Floating FloatingCard.
   *
   * @method onMouseOut
   */
  onMouseOut = () => this.setState({ elevation: 2 });

  /**
   * Renders a Floating FloatingCard.
   *
   * @method render
   */
  render() {
    const { children } = this.props;
    return (
      <Card
        onMouseOver={this.onMouseOver}
        onFocus={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onBlur={this.onMouseOut}
        elevation={this.state.elevation}
        {...this.props}
      >
        {children}
      </Card>
    );
  }
}

FloatingCard.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default FloatingCard;
